import React from 'react';
import { classes } from './Section.classes';
import { useId } from '../../../utils/useId';
import { SectionHeader } from '../../../SectionHeader';
import { SectionProps } from './Section.types';
import { dataHooks } from '../../constants';

const Section = ({
  title,
  titleVisible = true,
  suffix,
  children,
  ariaLabel,
  dataHook,
  as,
  'aria-describedby': ariaDescribedBy,
  id,
}: SectionProps) => {
  const generatedId = useId('title_');
  const titleId = id || generatedId;

  const getAriaLabel = () => {
    if (typeof title !== 'string') {
      return ariaLabel;
    }

    return ariaLabel || title;
  };

  return (
    <div
      data-hook={dataHook}
      data-title={typeof title === 'string' ? title : undefined}
      className={classes.root()}
    >
      {titleVisible && (
        <SectionHeader
          id={titleId}
          skin="neutral"
          divider="bottom"
          align="start"
          size="small"
          horizontalPadding="large"
          title={title}
          suffix={suffix}
          dataHook={dataHooks.sidePanelSectionHeader}
          as={as}
          aria-describedby={ariaDescribedBy}
        />
      )}
      <div
        role="group"
        aria-label={getAriaLabel()}
        aria-labelledby={titleVisible ? titleId : undefined}
      >
        {children}
      </div>
    </div>
  );
};

Section.displayName = 'Section';

export { Section };
